import React from 'react';
import { Bell, Check, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { notificationIcons, notificationLine, notificationTime } from './notificationContent';

export const NotificationRow = ({ item, busy, onOpen, onRead, onDelete }) => {
  const { t, i18n } = useTranslation('common');
  const Icon = notificationIcons[item.kind] || Bell;
  const line = notificationLine(item, t);
  return <li className={`flex items-start gap-1 px-2 py-2 ${item.read ? '' : 'bg-amber-500/[0.06]'}`}
    data-testid={`notif-row-${item.id}`} data-read={item.read ? 'true' : 'false'}>
    <button type="button" disabled={!!busy} onClick={onOpen} title={line}
      className="flex min-w-0 flex-1 items-start gap-2 rounded-md px-2 py-1.5 text-left transition-colors hover:bg-secondary/50 disabled:opacity-70"
      data-testid={`notif-open-${item.id}`}>
      <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary gold-text"><Icon className="h-3.5 w-3.5" /></span>
      <span className="min-w-0 flex-1">
        <span className={`block break-words text-xs leading-snug ${item.read ? 'text-muted-foreground' : 'font-semibold text-foreground'}`} data-testid={`notif-text-${item.id}`}>{line}</span>
        <time dateTime={item.created_at} className="mt-1 block text-[10px] text-muted-foreground" data-testid={`notif-time-${item.id}`}>{notificationTime(item.created_at, i18n.language)}</time>
      </span>
      {!item.read && <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full gold-gradient" aria-label={t('notification_center.unread')} data-testid={`notif-unread-${item.id}`} />}
    </button>
    <div className="flex shrink-0 flex-col gap-1">
      <Button type="button" size="icon" variant="ghost" disabled={!!busy || item.read} onClick={onRead}
        className="h-8 w-8" aria-label={t(item.read ? 'notification_center.already_read' : 'notification_center.mark_read')}
        title={t(item.read ? 'notification_center.already_read' : 'notification_center.mark_read')} data-testid={`notif-read-${item.id}`}>
        <Check className={`h-4 w-4 ${item.read ? 'text-muted-foreground' : 'gold-text'}`} />
      </Button>
      <Button type="button" size="icon" variant="ghost" disabled={!!busy} onClick={onDelete}
        className="h-8 w-8 text-muted-foreground hover:text-red-500" aria-label={t('notification_center.delete')}
        title={t('notification_center.delete')} data-testid={`notif-delete-${item.id}`}><Trash2 className="h-4 w-4" /></Button>
    </div>
  </li>;
};